<script>
import {BPagination} from "bootstrap-vue";

export default {
  components: {BPagination},
  props: {
    modelValue: {
      type: Number || String,
      required: false,
    },
    totalCounts: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    setQuery(key, value) {
      const queries = {}
      queries[key] = value
      this.$router.push({
        path: this.$route.path,
        query: queries
      })
    }
  },
  computed: {
    computedModelValue: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.setQuery('pageNumber', val)
        this.$emit('input', val)
      }
    }
  },
  watch: {
    // modelValue: function (nv, ov) {
    //
    // },
  },
  model: {
    prop: 'modelValue',
    event: 'input',
  },

}
</script>

<template>
  <b-pagination
      v-model="computedModelValue"
      :total-rows="totalCounts"
      :per-page="perPage"
      first-number
      last-number
      class="mb-0 mt-1 mt-sm-0"
      prev-class="prev-item"
      next-class="next-item"
  >
    <template #prev-text>
      <feather-icon style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
      />
    </template>
    <template #next-text>
      <feather-icon
          icon="ChevronRightIcon"
          size="18"
      />
    </template>
  </b-pagination>
</template>

<style scoped>

</style>